import React from "react";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { useLocation } from "react-router-dom";
import PromoCodes from "./PromoCodes";
import { ThemeType } from "../../../../../redux/constants";
import {
    selectAllRegistration,
    selectRegistrationTotals,
    updatePromoCodes,
    updatePromoDiscounts,
} from "../../../../../redux/slices/registrationSlice";
import { selectAllFormSettings } from "../../../../../redux/slices/formSettingsSlice";
import { selectThemeSettings } from "../../../../../redux/slices/cmsSettingsSlice";
import { selectIsCms } from "../../../../../redux/slices/configSlice";
import { selectBaseUrl } from "../../../../../redux/slices/p2pSettingsSlice";

const ConnectedPromoCodes = () => {
    const { values } = useFormikContext();
    const { pathname = "" } = useLocation();
    const {
        currentRegistration,
        registrations = {},
        promoCodes = [],
        promoDiscounts = {},
    } = useSelector(selectAllRegistration);
    const { prePromoRegistrantTotal = 0 } = useSelector(
        selectRegistrationTotals,
    );
    const { id, hasActivePromos = false } = useSelector(selectAllFormSettings);
    const {
        p2pActionSettings: { removeParticipantLinkLabel = "Remove" },
        p2pPromo: {
            promoCodeLabel = "Promo Code",
            promoCodeAppliedLabel = "applied",
            applyButtonLabel = "Apply",
        },
    } = useSelector((state) => selectThemeSettings(ThemeType.SUMMARY, state));

    const isCms = useSelector(selectIsCms);
    const registration = registrations[0];
    const baseUrl = useSelector(selectBaseUrl);
    const getPrimaryRegistration = () => {
        if (
            currentRegistration === 0 &&
            pathname === `${baseUrl}/form/registration`
        ) {
            return values;
        }
        return registration;
    };

    const { Category = [] } = getPrimaryRegistration();
    const isPrepopulatedPrimaryConfirmed =
        currentRegistration === 0 ? !values?.Needs_To_Be_Reviewed : true;

    const isVisible =
        (isCms && hasActivePromos) ||
        (!isCms &&
            hasActivePromos &&
            isPrepopulatedPrimaryConfirmed &&
            prePromoRegistrantTotal > 0 &&
            Object.keys(registrations[0]).length > 0 &&
            Category.length > 0);

    const promoCodesProps = {
        isCms,
        formId: id,
        isVisible,
        promoCodes,
        promoDiscounts,
        registrations,
        updatePromoCodes,
        updatePromoDiscounts,
        removeParticipantLinkLabel,
        promoCodeLabel,
        promoCodeAppliedLabel,
        applyButtonLabel,
    };
    return <PromoCodes {...promoCodesProps} />;
};

export default ConnectedPromoCodes;
